import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./ProductPage.module.scss";
import ProductPageContent from "./ProductPageContent.model";
import getSubCategoriesList from "./helpers/getSubCategoriesList";

import { useSelector } from "react-redux";
import Anchor from "components/Anchor/Anchor";
import Dictionary from "components/Dictionary/Dictionary";
import IconViewer from "components/IconViewer/IconViewer";
import ImageViewer from "components/ImageViewer/ImageViewer";
import MediaCloudItem from "pages/Catalog/components/MediaCloudItem/MediaCloudItem";
import Sidemenu from "layout/Sidemenu/Sidemenu";
import useWindowDimensions from "hooks/useWindowDimensions";

const ProductPage: FunctionComponent<ProductPageContent> = (props) => {
    const { width } = useWindowDimensions();
    const currentPage = useSelector((state: any) => state.page);
    const [showSidemenu, setShowSidemenu] = useState<boolean>(false);

    const subCategories = getSubCategoriesList(props.subCategoriesList);

    useEffect(() => {
        if (width >= 768) {
            setShowSidemenu(true);
        }
    }, [width]);

    const image = props.mediaCloudImage1 ?? props.productImage;

    return (
        <div className={styles.wrapper}>
            {/* Sidemenu */}
            {showSidemenu === true ? <Sidemenu view="FIXED" /> : null}

            <div className={styles.inner}>
                <div className={styles.content}>
                    <div className={styles.media}>
                        {/* Image */}
                        {image ? (
                            <ImageViewer
                                className={styles.image}
                                src={image.url}
                                focalPoint={{ left: 0.5, top: 0.5 }}
                            />
                        ) : null}

                        {!image ? <div className={styles.no_image}>&otimes;</div> : null}
                    </div>
                    <div className={styles.info}>
                        <span className={styles.tagline}>{props.mainCategoryTitle}</span>
                        <h1 className={styles.headline}>{props.itemName}</h1>
                        {/* TODO: Format for rich text editor and pre: */}
                        <p className={styles.description}>{props.description}</p>

                        {/* B2B Button */}
                        {currentPage?.languageId === "da" ? (
                            <a
                                className={styles.shop_button}
                                href="https://b2b-dk.easyfood.dk/"
                            >
                                <span className={styles.button_label}>
                                    <Dictionary name="PRODUCT.BUY_ON_WEBSHOP" />
                                </span>
                            </a>
                        ) : null}

                        <div className={styles.area}>
                            <h3 className={styles.heading}>
                                <Dictionary name="PRODUCT.PRODUCT_AREA" />
                            </h3>

                            <ul>
                                <li>
                                    <strong>
                                        <Dictionary name="PRODUCT.ARTICLE_NUMBER" />
                                    </strong>
                                    <span>{props.sku}</span>
                                </li>
                                <li>
                                    <strong>
                                        <Dictionary name="PRODUCT.WEIGHT_PER_PC" />
                                    </strong>
                                    <span>{props.weightPerPcApprox}</span>
                                </li>
                                <li>
                                    <strong>
                                        <Dictionary name="PRODUCT.CATEGORY" />
                                    </strong>
                                    {subCategories && subCategories.length > 0 ? <span>{subCategories.join(", ")}</span> : null}
                                </li>
                                <li>
                                    <strong>
                                        <Dictionary name="PRODUCT.PIECES_PER_CARTON" />
                                    </strong>
                                    <span>{props.piecesPerCarton}</span>
                                </li>
                            </ul>
                        </div>

                        {props.productSheet ? (
                            <Anchor
                                className={styles.download}
                                to={props.productSheet.url}
                                target="_blank"
                            >
                                <IconViewer
                                    className={styles.download_icon}
                                    name="download"
                                />
                                <Dictionary name="PRODUCT.DOWNLOAD_PRODUCT_SHEET" />
                            </Anchor>
                        ) : null}
                    </div>
                </div>

                {/* TODO: Check if there is any marketing material*/}
                {props.mediaCloudImage1 ||
                props.mediaCloudImage2 ||
                props.mediaCloudImage3 ||
                props.mediaCloudImage4 ||
                props.mediaCloudA4Skilt1 ||
                props.mediaCloudA4Skilt2 ? (
                    <div className={styles.extra}>
                        <span className={styles.extra_tagline}>
                            <Dictionary name="PRODUCT.MEDIA_CLOUD" />
                        </span>

                        <h3 className={styles.extra_heading}>
                            <Dictionary name="PRODUCT.MARKETING_MATERIAL" />
                        </h3>

                        <div className={styles.list}>
                            {props.mediaCloudImage1 ? (
                                <MediaCloudItem
                                    className={styles.item}
                                    {...props.mediaCloudImage1}
                                    product={props}
                                />
                            ) : null}

                            {props.mediaCloudImage2 ? (
                                <MediaCloudItem
                                    className={styles.item}
                                    {...props.mediaCloudImage2}
                                    product={props}
                                />
                            ) : null}

                            {props.mediaCloudImage3 ? (
                                <MediaCloudItem
                                    className={styles.item}
                                    {...props.mediaCloudImage3}
                                    product={props}
                                />
                            ) : null}

                            {props.mediaCloudImage4 ? (
                                <MediaCloudItem
                                    className={styles.item}
                                    {...props.mediaCloudImage4}
                                    product={props}
                                />
                            ) : null}

                            {props.mediaCloudA4Skilt1 ? (
                                <MediaCloudItem
                                    className={styles.item}
                                    {...props.mediaCloudA4Skilt1}
                                    product={props}
                                />
                            ) : null}

                            {props.mediaCloudA4Skilt2 ? (
                                <MediaCloudItem
                                    className={styles.item}
                                    {...props.mediaCloudA4Skilt2}
                                    product={props}
                                />
                            ) : null}
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ProductPage;
